import axios from "axios";

export const getLanguages = payload => {
  return axios.get(`${process.env.VUE_APP_API_URL}/languages`);
};
